import "./globals.css";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { initSentry } from "./sentry/init-sentry";

initSentry();

const mq = window.matchMedia("(prefers-color-scheme: dark)");
const applyTheme = (dark: boolean) => {
	document.documentElement.classList.toggle("dark", dark);
};
document.documentElement.classList.add("antialiased");
applyTheme(mq.matches);
mq.addEventListener("change", (e) => applyTheme(e.matches));

const root = document.getElementById("root");

if (!root) throw new Error("Root element not found");

createRoot(root).render(<App />);
